export function getPortalUrl(url: string | undefined): Promise<string> | null {
  // Return null when url is empty
  if (!url || url === '') {
    return null;
  }

  // Try to match /arcgis/ in url
  const dirMatch = /https?:\/\/(.*)\/rest\//.exec(url);

  // If no match, then return null
  if (!dirMatch) {
    throw new Error(
      "Couldn't match to find webcontext (i.e. https://yourportal.com/arcgis)"
    );
  }

  // Get rest info url
  const restInfoUrl = `${dirMatch[0]}/info?f=json`;
  return fetch(restInfoUrl)
    .then((response) => response.json())
    .then((json: { owningSystemUrl: string }) => json.owningSystemUrl);
}

const agolReg = new RegExp(/https?:\/\/.*\.arcgis\.com/);

export function isValidUrl(str: string): boolean {
  return /^(?:(?:https?|ftp):)?\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[01])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4])|(?:(?:[\da-z\u00A1-\uFFFF][\w\u00A1-\uFFFF-]{0,62})?[\da-z\u00A1-\uFFFF]\.)+[a-z\u00A1-\uFFFF]{2,}\.?)(?::\d{2,5})?(?:[#/?]\S*)?$/i.test(
    str
  );
}

export function isAGOL(portalUrl: string): boolean {
  return agolReg.test(new URL(portalUrl).origin);
}

export function getRootUrl(portalUrl: string): string {
  return `${portalUrl}/sharing/rest`;
}

export function getFeatureLayerServer(
  featureLayerUrl: string
): [string, string] | null {
  const match = featureLayerUrl.match(/(.*\/(.*)\/\w+Server)\/\d+$/);
  if (match) {
    // 0: original url
    // 1: feature server url
    // 2: feature server name
    return [match[1], match[2]];
  }
  return null;
}
